import { render, staticRenderFns } from "./CTSVersionList.vue?vue&type=template&id=4dff2c71&"
import script from "./CTSVersionList.vue?vue&type=script&lang=js&"
export * from "./CTSVersionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CTSVersionList.vue"
export default component.exports